import { Projeto } from "../types"

export const removeServicoCamposProjeto = (projeto: Partial<Projeto>) => {
  return {
    ...projeto,
    valor_servico: 0,
    valor_servico_pis_cofins: 0,
    servico: null,
    codigo_servico: "",
    justificativa_valor_servico: null,
  }
}